import { useContext } from "react";
import { RenameJobsContext } from "../providers/RenameJobsProvider";

export default function useRenameJobs() {
  const context = useContext(RenameJobsContext);
  if (context === undefined) {
    throw new Error("useRenameJobs must be used within a RenameJobsProvider");
  }
  return context;
}
